import React from 'react';
import { motion } from 'framer-motion';
import { Scissors, Flower2, Pill } from 'lucide-react';
export function ProblemSection() {
  const dangers = [{
    icon: <Scissors size={32} data-id="element-333" />,
    text: 'Un hilo de coser tragado por accidente'
  }, {
    icon: <Flower2 size={32} data-id="element-334" />,
    text: 'Una planta de lirios en el florero'
  }, {
    icon: <Pill size={32} data-id="element-335" />,
    text: 'Una pastilla de paracetamol en el piso'
  }];
  return <section className="py-8 md:py-12 px-4 bg-neutral-900" data-id="element-336">
      <div className="container mx-auto max-w-4xl" data-id="element-337">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-338">
          <h2 className="text-3xl md:text-6xl font-display text-white mb-4" data-id="element-339">
            La mayoría de los accidentes terminan mal
            <br data-id="element-340" />
            <span className="text-red-500" data-id="element-341">
              no por falta de amor, sino de un protocolo.
            </span>
          </h2>
          <p className="text-lg md:text-xl text-neutral-400 max-w-2xl mx-auto" data-id="element-342">
            Confiamos en que "nunca le va a pasar nada", pero el peligro está en
            las cosas más cotidianas.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6" data-id="element-343">
          {dangers.map((danger, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-neutral-950 border border-neutral-800 p-8 rounded-2xl text-center flex flex-col items-center gap-4" data-id="element-344">
              <div className="w-16 h-16 rounded-full bg-red-500/10 text-red-500 flex items-center justify-center mb-2" data-id="element-345">
                {danger.icon}
              </div>
              <p className="text-lg font-medium text-neutral-200" data-id="element-346">
                {danger.text}
              </p>
              <p className="text-sm text-red-400 font-bold uppercase tracking-wider" data-id="element-347">
                Puede ser letal en horas
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand/10 border border-brand/20 p-8 rounded-2xl text-center" data-id="element-348">
          <p className="text-xl md:text-2xl text-white font-medium" data-id="element-349">
            Cuando la emergencia golpea, el pánico te bloquea y terminás
            perdiendo tiempo vital en Facebook preguntando qué hacer, cuando
            deberías estar actuando.
          </p>
        </motion.div>
      </div>
    </section>;
}